import { Reducer } from "../../lib/redux";
import { FeedVersionActionTypes } from "./types";
import { FeedVersionActions } from "./actions";
import { extend } from "../../utils/vanilla";

/*
FeedVersions has a bit of an oddly flexible structure. If you take a look at feedVersionsTests.ts,
you can see an example use case , justifying the definition looking like this.

The store is keyed by User --> FeedTypeKey for every key, aside from dvirVehicle / dvirTrailer, which
can accept a sub-dictionary (keyed by DVIR id). So, we can have a store that looks something like this.

(Note: dvirVehicle/Trailer do not HAVE to be sub-dictionaries, they just CAN be in some situations)
{
    // userId
    b4: {
        // FeedTypeKey --> string value
        hos: "000000000123",
        recipientTextMessage: "092480343094",

        // FeedTypeKey --> IIdDictionary<string>
        dvirVehicle: {
            d1: "9487593485",
            d2: "49085409534",
            d3: "984375947954"
        },
        dvirTrailer: {
            d4: "4387593485",
            d5: "02934537545"
        }
    }
}
*/
export let defaultFeedVersions: IIdDictionary<IIdDictionary<string | IIdDictionary<string>>> = {};

export let feedVersions: Reducer<IIdDictionary<IIdDictionary<string | IIdDictionary<string>>>, FeedVersionActions> = (state = defaultFeedVersions, action) => {
    switch (action.type) {
        case FeedVersionActionTypes.SET_FEEDVERSIONS: {
            const userId: string = action.payload.userId;
            if (userId) {
                return {
                    ...state,
                    [userId]: extend(true, {}, action.payload.feedVersions)
                };
            }
            return state;
        }
        case FeedVersionActionTypes.CLEAR_FEEDVERSIONS: {
            if (action.payload && action.payload.length > 0) {
                return Object.keys(state)
                    .filter(userId => action.payload.map(user => user.id).indexOf(userId) !== -1)
                    .reduce((curr, key) => ({
                        ...curr,
                        [key]: state[key]
                    }), {});
            }
            return {};
        }
        default:
            return state;
    }
};